import request from '@/config/axios'

// 查询全部区域
export const getRegionSimpleList = () => {
  return request.get({ url: '/system/business-region/simple-list' })
}

// 查询区域（精简）列表
export const getBusinessRegionList = () => {
  return request.get({ url: '/txn/org-business-region/list' })
}

// 修改我开通的区域
export const regionChangeStatus = (id) => {
  return request.post({ url: '/txn/org-business-region/changeStatus?id=' + id })
}

//////////////////////////////////店铺模块/////////////////////////////////////////////
export interface TxnStoreDO {
  id?: number
  orgId?: number
  enteName?: string
  regionId?: number
  regionName?: string
  storeCode?: string
  storeName?: string
  website?: string
  logoUrl?: string
  bannerUrl?: string
  intro?: string
  status?: number
  auditStatus?: number
  contactName?: string
  contactPhone?: string
  createTime?: string
  remark?: string
  address?: string
}


// 保存店铺信息
export const saveStoreInfo = (data) => {
  return request.post({ url: data.id?'/txn/store/update':'/txn/store/create', data })
}
export const getStoreList = (params) => {
  return request.get({ url: '/txn/store/list', params })
}
export const getStoreSimpleList = (params) => {
  return request.get({ url: '/txn/store/simple-list', params })
}
export const submitStoreCert = (data) => {
  return request.post({ url: '/txn/store/submitStoreCert', data })
}
export const suspendStore = (id) => {
  return request.post({ url: '/txn/store/suspendStore?id='+id })
}


//////////////////////////////////套餐模块/////////////////////////////////////////////


export interface TxnPackageDO {
  id?: number
  no?: string                        // 套餐编号
  name?: string                      // 套餐名称
  storeId?: number                   // 所属店铺 ID
  store?: {                          // 所属店铺
    id?: number
    storeName?: string
  }
  organization?: {                   // 发布组织
    id?: number
    orgName?: string
    parentId?: number | null
  }
  regionId?: number                  // 所属区域
  customerType?: number              // 客户类型（1 一般工商业 2 大工业 3 高耗能 4 其他）
  greenPower?: boolean               // 是否绿电
  tradePeriodType?: number           // 套餐分类（1 年度 2 月度）
  priceMode?: number                 // 定价方式（1 固定价格 2 服务费 3 浮动价格 4 分成方式）
  imageUrl?: string                  // 套餐图片
  contractTemplateUrl?: string       // 合同模板 URL
  intro?: string                     // 套餐介绍（富文本）
  status?: number                    // 状态
  publishTime?: number               // 发布时间
  remark?: string | null             // 备注
  // 电量权重
  peakEnergyWeight?: number          // 峰时电量权重
  flatEnergyWeight?: number          // 平时电量权重
  valleyEnergyWeight?: number        // 谷时电量权重
  totalEnergyWeight?: number         // 总电量权重
  // 均价
  peakAvgPrice?: number              // 峰时均价
  flatAvgPrice?: number              // 平时均价
  valleyAvgPrice?: number            // 谷时均价
  totalAvgPrice?: number             // 综合均价
  // 订单
  totalOrderNum?: number             // 总销量
  pendingOrderNum?: number           // 待处理订单数
  hasPendingOrder?: boolean          // 是否有待处理订单
  periodList?: any[] | null          // 时段列表
}


// 保存店铺信息
export const savePackage = (data) => {
  return request.post({ url: data.id?'/txn/packagee/update':'/txn/packagee/create', data })
}
export const getPackageList = (params) => {
  return request.get({ url: '/txn/packagee/list', params })
}
export const deletePackage = (data) => {
  return request.post({ url: '/txn/store/submitStoreCert', data })
}
export const getPackageDetail = (id: number) => {
  return request.get({ url: '/txn/packagee/get/detail?id=' + id })
}
export const packagePublish = (id: any) => {
  return request.post({ url: '/txn/packagee/publish?id=' + id })
}
export const packageOffline = (id: any) => {
  return request.post({ url: '/txn/packagee/offline?id=' + id })
}


// ocr 识别营业执照
export const licenseOcrApi = (imageUrl) => {
  return request.get({ url: '/infra/ocr/recognizeBizLicense', params: {imageUrl: imageUrl} })
}

//////////////////////////////////签约企业模块/////////////////////////////////////////////
export interface TxnCompanyDO {
  id?: number
  memberId?: number
  member?: {
    id?: number
    mobile?: string
    nickname?: string
    avatar?: string
  }
  regionId?: number           // 所属区域ID
  companyName?: string        // 企业名称
  licenseNo?: string          // 营业执照号
  licenseImgUrl?: string      // 营业执照图片
  legalPerson?: string        // 法人
  companyType?: string        // 企业类型
  contactName?: string        // 联系人
  contactMobile?: string      // 联系电话
  industryId?: number
  industryName?: string       // 行业名称
  industryTraceName?: string  // 行业全路径
  address?: string            // 地址
  accountNo?: string          // 账号
  signOrderNum?: number       // 签约订单数
}

// 查询签约企业分页
export const getSignedCompanyPage = (params) => {
  return request.get({ url: '/txn/company/page-signed', params })
}

//////////////////////////////////员工管理模块/////////////////////////////////////////////
export interface TxnUserDO {
  id?: number
  orgId?: number           // 所属企业ID
  orgName?: string         // 所属企业名称
  deptId?: number          // 部门ID
  deptName?: string        // 部门名称
  username?: string        // 用户名
  nickname?: string        // 昵称
  email?: string           // 邮箱
  sex?: number             // 性别
  avatar?: string          // 头像
  password?: string        // 密码（仅新增）
  status?: number          // 状态 0禁用 1启用
  loginIp?: string         // 最后登录IP
  loginDate?: number       // 最后登录时间（时间戳）
  createTime?: number      // 创建时间（时间戳）
}

// 查询员工分页
export const getUserPage = (params) => {
  return request.get({ url: '/txn/user/page', params })
}

// 新增员工
export const createUser = (data: TxnUserDO) => {
  return request.post({ url: '/txn/user/create', data })
}

// 更新员工
export const updateUser = (data: TxnUserDO) => {
  return request.post({ url: '/txn/user/update', data })
}

// 获取角色简易列表（用于分配角色）
export const getRoleSimpleList = () => {
  return request.get({ url: '/txn/role/simple-list' })
}

// 分配用户角色
export const assignUserRole = (data: { userId: number, roleIds: number[] }) => {
  return request.post({ url: '/txn/permission/assign-user-role', data })
}

// 查询用户已有的角色列表
export const getUserRoleList = (userId: number) => {
  return request.get({ url: '/txn/permission/list-user-roles?userId=' + userId })
}